import React from "react";

const CalcTitle = (props) => {
  return <div className="calculator-title">{props.value}</div>;
};
export default CalcTitle;
